import React, { useContext } from "react";
import { UserContext } from "@/store/context/UserContext.tsx";

import { Link } from "react-router-dom";
import { isPlatform, platformMostAI } from "@/domains.ts";
import { useQuery } from "react-query";
import { queryKey } from "@/store/queryKeys.ts";
import { constants } from "@/constants";
import { SidebarButton } from "@/components/partials/sidebar/SidebarButton.tsx";
import {Icon} from "@/components/Icon.tsx";

export const ProfileSidebarButton: React.FC = () => {
  const { userSettings } = useContext(UserContext);

  let balanceQuery = useQuery(queryKey.balance, async function () {
    if (!isPlatform(platformMostAI)) {
      return;
    }
    let res = await fetch(`${constants.url.API_PREFIX}billing/balance`);
    return res.json();
  });

  if (!userSettings.userID) {
    return null;
  }

  if (!isPlatform(platformMostAI)) {
    return (
      <Link to="/profile">
        <div className="flex items-center justify-between p-2 btn btn-outline-dark">
          <div className="flex items-center">
            <Icon
              icon="fluent:wallet-48-regular"
              height={32}
              width={32}
              className="w-8 inline-block mr-1"
            />
            <span>{userSettings.messageCredits}</span>
          </div>
          <div className="bg-slate-700 px-2 py-0.5 rounded text-white text-sm">
            {userSettings.subscription?.active
              ? userSettings.subscription?.product_name
              : "Free"}
          </div>
        </div>
      </Link>
    );
  } else {
    return (
      <Link to="/profile">
        {balanceQuery.data && (
          <SidebarButton
            icon="fluent:person-circle-32-regular"
            imageUrl={userSettings.avatar_url}
          >
            <p className="font-semibold truncate">
              {userSettings.name ? userSettings.name : userSettings.email}
            </p>
            <div className="flex items-center">
              <div>{balanceQuery.data.balance.toFixed(2)}&nbsp;₽</div>
              {!!balanceQuery.data.bonuses && (
                <div className="ml-2 bg-slate-500 px-1 rounded-md text-white flex items-center gap-0.5">
                  {balanceQuery.data.bonuses.toFixed(2)}
                  <Icon icon="fluent:star-20-filled" width={18} />
                </div>
              )}
            </div>
          </SidebarButton>
        )}
      </Link>
    );
  }
};
